import { from, of } from 'rxjs'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { RootEpic } from '~/Store/types'
import { errorNotification } from '~/Services'
import { UsersActions } from './slice'
import { RolesService } from '~/Services/AdminRolesService'
import { UserService } from '~/Services/AdminUsers'

const getAllUsers: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(UsersActions.getUsersRequest.match),
    switchMap(() => {
      return from(UserService.Get.getAllUsers()).pipe(
        map(res => UsersActions.setUsersSuccess(res.data)),
        catchError(error => {
          errorNotification(error)
          return of(UsersActions.setUsersError())
        }),
      )
    }),
  )

export const UsersEpics = [getAllUsers]
